module.exports = __webpack_public_path__ + "p4_img1.png?8ec7fded9f718e1b238b24f8dc0e5dd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img1.png
// module id = 54
// module chunks = 0